<ng-container *ngIf="canView" style="height: 300px; margin: 10px 0px;">

  <mat-expansion-panel *ngIf="!isValidating" [expanded]="true" style="margin: 10px 0px;">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <mat-icon style="margin-top: -3px; margin-right: 5px;">pie_chart</mat-icon>Gastos por Servicio
      </mat-panel-title>
      <mat-panel-description>
      </mat-panel-description>
    </mat-expansion-panel-header>

    <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="isSearching">
      <mat-label style="margin: 10px 0px;"><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>
    </div>

    <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="!isSearching" style="justify-content: center; margin-top: -18px;">

      <div fxFlex=100 fxFlex.xs=100 class="flex-item" *ngIf="data == null || data.length == 0" style="text-align: center; font-weight: bold;">
        <mat-label>No hay datos para mostrar.</mat-label>
      </div>

      <div fxFlex=100 fxFlex.xs=100 class="flex-item" *ngIf="data != null && data.length > 0">

        <ejs-accumulationchart [tooltip]="tooltipGastoServicio" [legendSettings]="legendSettingsGastoServicio" 
          #pieGastoServicio style='display:block;  width: 92%' (load)='load($event)'>
          <e-accumulation-series-collection>
            <e-accumulation-series name='Servicios' [dataSource]='data' xName='NombreGrupo' yName='CantidadGrupo'
              [startAngle]='startAngle' innerRadius="0%" [radius]="radius" legendShape='Circle'>
            </e-accumulation-series>
          </e-accumulation-series-collection>
        </ejs-accumulationchart>

      </div>

    </div>

  </mat-expansion-panel>
  
</ng-container>